import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'fortinet-coverletter',
  templateUrl: './fortinet.coverletter.component.pug',
  styleUrls: ['./fortinet.coverletter.component.styl']
})
export class FortinetCoverletterComponent implements OnInit {

	public constructor(private titleService: Title) { }
  
	title: string;
	subtitle: string;
	tirtitle: string;
	company: string;

	ngOnInit() {
		this.title='Fortinet Technologies Canada';
		this.subtitle='Hiring Manager';
		this.titleService.setTitle("Introducing Liam Hogan Cover Letter");
		this.tirtitle='';
		this.company='Fortinet';
	}

}
